import React, { useContext,useEffect,useState } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import { ThemeProvider } from "styled-components";
import Categories from "./components/menu/Categories";
import Meal from "./components/menu/Meal";
import MenuWrapper from "./components/menu/MenuWrapper";
import MenuChooser from "./components/menu/MenuChooser";
import GlobalContext from "./context/GlobalContext";
import Search from './components/menu/Search';
import NavbarComponent from "./components/navbar/NavbarComponent";
import FabRenderer from "../src/components/common/FabRenderer";

const Routes = () => {
  const context = useContext(GlobalContext);
  const [fabVisible, setFabVisible] = useState(false);
  const [bannerVisible, setbannerVisible] = useState(false);

  useEffect(() => {
    const social = context.configuration?.restaurantDetails?.socialMedia;
    const banner = context.configuration?.restaurantDetails?.banner;
    const parallaxUploaded = context.configuration?.restaurantDetails?.parallaxUploaded;
    if(parallaxUploaded.startsWith("http")){
      let styleElem = document.head.appendChild(document.createElement("style"));

      styleElem.innerHTML = `body:before {background-image: url(${parallaxUploaded});}`;
    }


    if(banner.startsWith("http")) {
      setbannerVisible(true);
      console.log("banner",bannerVisible)
      context.setBanner(true);
      
    }

    let visible = false;
  if(social){
    for (const [key,value] of Object.entries(social)) {
      if(value.enabled) visible = true;
    }
    if(!visible) {
      const table = localStorage.getItem("call") || context.configuration.table;
      if(table && table.length > 0) {
        visible = true;
    }
  }
}
console.log("fab actions",context.configuration?.fab?.actions);
setFabVisible(visible);
  }, []);
  
  return (
    <ThemeProvider theme={context.configuration.uiConfig}>
                  {(context.configuration?.fab?.action && fabVisible) && <FabRenderer />}
                  {/* {context.banner && <BannerRenderer image={context.configuration?.restaurantDetails?.banner} />} */}

    <Router>
      <Route path="/" component={NavbarComponent}/>
      <Route exact path="/:restaurantId?" component={MenuChooser} />
      <Route exact path="/:restaurantId/categories/:type" component={Categories} />
      <Route exact path="/:restaurantId/categories/:type/:category" component={MenuWrapper} />
      <Route exact path="/:restaurantId/categories/:type/:category/:itemId" component={Meal} />
      <Route exact path="/:restaurantId/tags/:tag" component={Search}/>
    </Router>
    </ThemeProvider>
  );
};

export default Routes;
